import QRCode from "react-qr-code"
import phonepe_svg from '../media/phonepe.svg'
import gpay_svg from '../media/GPay.svg'
import bhim_svg from '../media/BHIM.svg'
import paytm_svg from '../media/paytm.svg'
import valueLinkLogo from '../media/pakistan_payments/value_link_global.png'
import jazzcashQR from "../media/pakistan_payments/jazzcash_qr.png"
import easypaisa from "../media/pakistan_payments/easypaisa_qr.png"
import exclamation_Svg from "../media/pakistan_payments/exclamation-mark.svg"
import CopyToClipboard from "react-copy-to-clipboard"
import { useEffect, useRef, useState } from "react"
import "./PakistanPayment.css"
import { createWorker } from "tesseract.js"

const PakistanPaymentPage = ({ paymentImg,
    orderDetails,
    pendingConfirmation,
    config,
    ispaid,
    qrRef,
    redirectLinks,
    showUTRNumber,
    redirectToPaymentApp,
    openWithSelectedApps,
    setOrderDetails,
    cancelButton,
    getBase64,
    fileValue,
    setFileValue,
    copyToClipboard,
    image,
    removeImg,
    togglePreview,
    errMsg,
    selectedMethod,
    setSelectedMethod
}) => {

    const [showCopiedInfo, setShowCopiedInfo] = useState(false)
    const [isPortrait, setIsPortrait] = useState(window.innerHeight > window.innerWidth)
    const workerRef = useRef(null)

    useEffect(() => {
        const handleResize = () => {
            if (window.innerHeight > window.innerWidth) {
                setIsPortrait(true)
            } else {
                setIsPortrait(false)
            }
        }
        window.addEventListener("resize", handleResize)
        const initWorker = async () => {
            workerRef.current = await createWorker("eng");
        };
        initWorker();
        return () => {
            window.removeEventListener("resize", handleResize);
            workerRef.current?.terminate();
        }
    }, [])

    const handleCopiedMessage = () => {
        setShowCopiedInfo(true)
        setTimeout(() => {
            setShowCopiedInfo(false)
        }, 1000)
    }

    const extractTextFromImage = async (file) => {
        if (!workerRef.current) return;

        const { data: { text } } = await workerRef.current.recognize(file);
        const match = text.match(
            /(?:T\s*I\s*D|Txn\s*ID|Transaction\s*ID|TransactionID|ransaction\s*ID)[:\s]*([0-9]+)/i
        );
        const transactionId = match ? match[1] : null;

        if (transactionId) {
            setOrderDetails({ ...orderDetails, utr: transactionId })
        }
    };

    return <div className="content valueLinkPaymentPage">
        {isPortrait && <div className="portrait-wrapper">
            <div className="top-bar">
                <div className="close-btn" data-title="Cancel Transaction" onClick={cancelButton}>
                    {/* <svg viewBox="0 0 24 24" stroke-width="2.5" stroke-linecap="round" fill="none"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg> */}
                    <i className="fa-solid fa-x" style={{ color: "var(--white)" }}></i>
                </div>
                <div className="logo-pill">
                    <div className="logo-icon"><img src={valueLinkLogo} height="50px" alt="Value Link Global" draggable="false" /></div>
                </div>
                <div className="top-right">
                    <div id="countdown" className="timer">00:00</div>
                </div>
            </div>

            <div className="payment-card">
                <div className="tab-bar">
                    {redirectLinks?.qr.map(t =>
                        <div key={t?.payMethod} type="button" aria-checked={selectedMethod?.payMethod === t?.payMethod}
                            role="radio" className={`tab${selectedMethod?.payMethod === t?.payMethod ? " activePakPayMethod" : ""}`} onClick={() => { setSelectedMethod(t); setOrderDetails((prev) => ({ ...prev, payMethod: t?.payMethod })) }}>{t?.payMethod}</div>
                    )}
                </div>

                <div className="payment-card-body">
                    <div className="section-label">Scan & Pay</div>
                    <div className="qr-sub section-sub">
                        <img src={exclamation_Svg} className="exclamation-icon" alt="warning" draggable="false"></img>
                        Single use only - reusing will result in loss of funds
                    </div>

                    <div className="qr-frame">
                        <div className="qr-corners">
                            <div className="corner corner-tl"></div>
                            <div className="corner corner-tr"></div>
                            <div className="corner corner-bl"></div>
                            <div className="corner corner-br"></div>
                        </div>

                        <img height={250} style={{ maxWidth: "100%" }} src={'data:image/png;base64,' + selectedMethod?.qrCode} alt="qrCode" draggable="false" />
                        {/* <img height={250} className="qr-placeholder" src={easypaisa} alt="qrCode" draggable="false" /> */}
                        <div className="qr-hint">Pay with {selectedMethod?.payMethod} app or scan QR</div>
                        {Boolean(selectedMethod?.bankName) && <span className="bankerName">{selectedMethod?.bankName ?? ""}</span>}
                    </div>
                    {Boolean(orderDetails?.upiId) && <div className="Tid-container">TILL ID: <span style={{ color: "var(--teal-bright)" }}>{orderDetails?.upiId}</span>  <CopyToClipboard text={orderDetails?.upiId} onCopy={handleCopiedMessage}>
                        <i className="fa-regular fa-copy" style={{ fontSize: "24px", color: "var(--teal-bright)", cursor: "pointer" }}>
                            {showCopiedInfo && <div className="copiedToClipBoard">Copied</div>}
                        </i>
                    </CopyToClipboard>
                    </div>}
                    {Boolean(errMsg) && <div class="error-badge">{errMsg}</div>}
                    <div className="info-grid">
                        <div className="info-chip" style={{ gridColumn: "1/-1" }}>
                            <div className="info-chip-label">Order ID</div>
                            <div className="info-chip-value" style={{ fontSize: "11px" }}>51d047dc-014d-01b2-a008-222c61025f39</div>

                            <div className="info-chip-label mt-1">Amount</div>
                            <div className="info-chip-value amount">{redirectLinks?.currency ?? ""} {Number(orderDetails?.amount ?? 0).toFixed(2)}</div>
                        </div>
                    </div>

                    <div className="divider"></div>

                    <div className="form-section">
                        {!Boolean(fileValue) && <div className="upload-zone glowUploadZone" onClick={() => document.getElementById("paymentProof").click()}>
                            <div className="upload-icon">
                                <input type="file" className="mb-4" placeholder="Upload Payment Proof" accept="image/png,image/jpg,image/jpeg" style={{ color: "#000", display: "none" }} onChange={(e) => { extractTextFromImage(e.target.files[0]); getBase64(e); setFileValue(e.target.value?.split("\\").pop()); }} name="paymentProof" id="paymentProof" />
                                <i className="fa-solid fa-arrow-up-from-bracket"></i>
                            </div>
                            <div className="upload-text">
                                Upload Payment Proof
                                <span>JPG, PNG or JPEG · Max 500KB</span>
                            </div>
                        </div>}
                        {Boolean(fileValue) && <div className="upload-zone" onClick={togglePreview}>
                            <div className="uploaded-icon">
                                <i className="fa-regular fa-circle-check"></i>
                            </div>
                            <div className="upload-text">
                                <div className="text-truncate">{fileValue}</div>
                                <span>Click Here To Preview</span>
                            </div>
                            <div className="uploaded-icon ms-auto" id="removeImg" onClick={(e) => { e.stopPropagation(); removeImg() }}>
                                <i className="fa-solid fa-trash" style={{ color: "var(--very-danger)" }}></i>
                            </div>
                        </div>}

                        <input className="tid-input" type="text" placeholder="Enter Transaction ID (TID)" value={orderDetails?.utr} onChange={(e) => { ((/^[1-9][0-9]*$/.test(e.target.value) || e.target.value === '') && setOrderDetails({ ...orderDetails, utr: e.target.value })) }} id="utr" name="utr" required />

                        <button className="confirm-btn" disabled={!paymentImg} onClick={() => { paymentImg && pendingConfirmation() }}>Confirm Payment →</button>
                    </div>
                </div>
            </div>
        </div>
        }

        {
            !isPortrait && <div className="landscape-wrap">
                <div className="top-bar">
                    <div className="close-btn" data-title="Cancel Transaction" onClick={cancelButton}>
                        {/* <svg viewBox="0 0 24 24" stroke-width="2.5" stroke-linecap="round" fill="none"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg> */}
                        <i className="fa-solid fa-x" style={{ color: "var(--white)" }}></i>
                    </div>
                    <div className="logo-pill">
                        <div className="logo-icon"><img src={valueLinkLogo} height="50px" alt="Value Link Global" draggable="false" /></div>
                    </div>
                    <div className="top-right">
                        <div id="countdown" className="timer">00:00</div>
                    </div>
                </div>

                <div className="payment-card">
                    <div className="tab-bar">
                        {/* {[{ "payMethod": "easyPaisa" }, { "payMethod": "jazzCash" }].map(t => */}
                        {redirectLinks?.qr.map(t =>
                            <div key={t?.payMethod} type="button" aria-checked={selectedMethod?.payMethod === t?.payMethod}
                                role="radio" className={`tab${selectedMethod?.payMethod === t?.payMethod ? " activePakPayMethod" : ""}`} onClick={() => { setSelectedMethod(t); setOrderDetails((prev) => ({ ...prev, payMethod: t?.payMethod })) }}>{t?.payMethod}</div>
                        )}
                    </div>

                    <div className="payment-card-body">
                        <div className="qr-side">
                            <div className="qr-header">
                                <div className="qr-title">Scan & Pay</div>
                                <div className="qr-sub">
                                    <img src={exclamation_Svg} className="exclamation-icon" alt="warning" draggable="false"></img>
                                    Single-use QR - do not reuse
                                </div>
                            </div>

                            <div className="qr-frame">
                                <div className="qr-corners">
                                    <div className="corner corner-tl"></div>
                                    <div className="corner corner-tr"></div>
                                    <div className="corner corner-bl"></div>
                                    <div className="corner corner-br"></div>
                                </div>
                                <img height={250} style={{ maxWidth: "100%" }} src={'data:image/png;base64,' + selectedMethod?.qrCode} alt="qrCode" draggable="false" />
                                {/* <img height={250} className="qr-placeholder" src={easypaisa} alt="qrCode" draggable="false" /> */}
                                <div className="qr-hint">Pay with {selectedMethod?.payMethod} app or scan QR</div>
                                {Boolean(selectedMethod?.bankName) && <span className="bankerName">{selectedMethod?.bankName ?? ""}</span>}
                            </div>
                            {Boolean(orderDetails?.upiId) && <div className="Tid-container">TILL ID: <span style={{ color: "var(--teal-bright)" }}>{orderDetails?.upiId}</span>  <CopyToClipboard text={orderDetails?.upiId} onCopy={handleCopiedMessage}>
                                <i className="fa-regular fa-copy" style={{ fontSize: "24px", color: "var(--teal-bright)", cursor: "pointer" }}>
                                    {showCopiedInfo && <div className="copiedToClipBoard">Copied</div>}
                                </i>
                            </CopyToClipboard>
                            </div>}
                        </div>

                        <div className="form-side">
                            <div className="order-info">
                                <div className="info-row">
                                    <div className="info-chip">
                                        <div className="info-chip-label">Order ID</div>
                                        <div className="info-chip-value" style={{ fontSize: "11.5px", fontFamily: "monospace", letterSpacing: "0.3px" }}>{orderDetails?.orderId ? orderDetails?.orderId : "N/A"}</div>
                                    </div>
                                    <div className="info-chip">
                                        <div className="info-chip-label">Amount</div>
                                        <div className="amount-display">
                                            <span className="amount-currency">{redirectLinks?.currency ?? ""}</span>
                                            <span className="amount-value">{Number(orderDetails?.amount ?? 0).toFixed(2)}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="divider"></div>

                            <div className="form-section">
                                <div className="form-label">Upload Receipt</div>

                                {!Boolean(fileValue) && <div className="upload-zone glowUploadZone" onClick={() => document.getElementById("paymentProof").click()}>
                                    <div className="upload-icon">
                                        <input type="file" className="mb-4" placeholder="Upload Payment Proof" accept="image/png,image/jpg,image/jpeg" style={{ color: "#000", display: "none" }} onChange={(e) => {
                                            extractTextFromImage(e.target.files[0]); getBase64(e); setFileValue(e.target.value?.split("\\").pop()); const file = e.target.files[0];
                                        }} name="paymentProof" id="paymentProof" />
                                        <i className="fa-solid fa-arrow-up-from-bracket"></i>
                                    </div>
                                    <div className="upload-text">
                                        Upload Payment Proof
                                        <span>JPG, PNG or JPEG · Max 500KB</span>
                                    </div>
                                </div>}
                                {Boolean(fileValue) && <div className="upload-zone" onClick={togglePreview}>
                                    <div className="uploaded-icon">
                                        <i className="fa-regular fa-circle-check"></i>
                                    </div>
                                    <div className="upload-text">
                                        <div className="text-truncate">{fileValue}</div>
                                        <span>Click Here To Preview</span>
                                    </div>
                                    <div className="uploaded-icon ms-auto" id="removeImg" onClick={(e) => { e.stopPropagation(); removeImg() }}>
                                        <i className="fa-solid fa-trash" style={{ color: "var(--very-danger)" }}></i>
                                    </div>
                                </div>}

                                <input className="tid-input" type="text" placeholder="Enter Transaction ID (TID)" value={orderDetails?.utr} onChange={(e) => { ((/^[1-9][0-9]*$/.test(e.target.value) || e.target.value === '') && setOrderDetails({ ...orderDetails, utr: e.target.value })) }} id="utr" name="utr" required />

                                <button className="confirm-btn" disabled={!paymentImg} onClick={() => { paymentImg && pendingConfirmation() }}>Confirm Payment →</button>
                            </div>
                        </div>
                    </div>
                </div>
                {Boolean(errMsg) && <div class="error-badge">{errMsg}</div>}
            </div>
        }
    </div >
}

export default PakistanPaymentPage